import type { QueryClient, QueryKey } from "@tanstack/query-core";

/** Cancel even an initial read before refetching after a successful write.
 * invalidateQueries alone does not replace a pending query without data.
 */
export async function invalidateResourceQueries({
  client,
  queryKeys,
}: {
  readonly client: QueryClient;
  readonly queryKeys: readonly QueryKey[];
}): Promise<void> {
  await Promise.all(
    queryKeys.map((queryKey) => client.cancelQueries({ queryKey })),
  );
  await Promise.all(
    queryKeys.map((queryKey) => client.invalidateQueries({ queryKey })),
  );
}
